export type AiDifficulty = 'relaxed' | 'standard' | 'intense'

export interface GameSettings {
  aiDifficulty: AiDifficulty
}

export function createGameSettings(
  aiDifficulty: AiDifficulty = 'standard',
): GameSettings {
  return { aiDifficulty }
}

export function isAiDifficulty(value: unknown): value is AiDifficulty {
  return (
    value === 'relaxed' ||
    value === 'standard' ||
    value === 'intense'
  )
}

export function isGameSettings(value: unknown): value is GameSettings {
  return (
    typeof value === 'object' &&
    value !== null &&
    'aiDifficulty' in value &&
    isAiDifficulty(value.aiDifficulty)
  )
}

export function getAiDifficultyLabel(
  difficulty: AiDifficulty,
): string {
  const labels: Record<AiDifficulty, string> = {
    relaxed: '宽松',
    standard: '标准',
    intense: '高压',
  }

  return labels[difficulty]
}
